import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import NavBar from '@/components/NavBar'
import MainMenu from '@/components/MainMenu'
import NotificationContainer from '@/components/NotificationContainer'
import VersionTag from '@/components/VersionTag'
import Vuelidate from 'vuelidate'
import moment from './plugins/momentInstall.js'

Vue.config.productionTip = false
Vue.use(moment)
Vue.use(Vuelidate)

//Registrando componentes globales
Vue.component('NavBar', NavBar)
Vue.component('MainMenu', MainMenu)
Vue.component('NotificationContainer', NotificationContainer)
Vue.component('VersionTag', VersionTag)

const user = JSON.parse(localStorage.getItem('user'))

if (user) {
  store.dispatch('user/setUser', user)
}

store.dispatch('mainTheme/setAppTheme', {
  backgroundWelcome: process.env.VUE_APP_THEME_BACKGROUND_WELCOME,
  backgroundColor: process.env.VUE_APP_THEME_BACKGROUND_COLOR,
  components: {
    mainColor: process.env.VUE_APP_THEME_COMPONENTS_MAIN_COLOR
  },
  dragFiles: {
    selectFileButtonColor: process.env.VUE_APP_THEME_SELECT_FILE_BUTTON_COLOR
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')